import $axios from "../utils/axios-api-config";
export default {
  createRoom(payload: any) {
    return $axios.post(`/daily_co/create-video-call`, payload);
  },
  deleteRoom(roomName: any) {
    return $axios.delete(`/daily_co/deleteRoom/${roomName}`);
  },
};
